module.exports = __webpack_public_path__ + "img/lacerta.74749784.png";